import { StatusType } from '@/app/types/constantDataType'
import { ManageOfferListing } from '@/app/types/offerListing'
import { SponsererOfferClientSecretResponse } from '@/app/types/offersType'
import { apiSlice } from '../apiSlice'

export const offerApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRelatedOffers: builder.query({
      query: (offerId) => `/sales_offers/${offerId}/related`,
      transformResponse: async (responseData) => {
        return responseData
      },
      providesTags: ['Offers'],
    }),
    getSponseredOfferClientSecret: builder.mutation<
      SponsererOfferClientSecretResponse,
      {
        quantity: string
        duration: string
      }
    >({
      query: ({ quantity, duration }) => ({
        url: 'one_time_payment/sponsored_offer',
        method: 'POST',
        body: { quantity: quantity, duration: duration },
      }),
    }),
    addOffer: builder.mutation<
      { status: StatusType; errors: string[] },
      { salesOfferPayload: FormData }
    >({
      query: ({ salesOfferPayload }) => ({
        url: '/sales_offers',
        method: 'POST',
        body: salesOfferPayload,
      }),
      invalidatesTags: ['Offers'],
    }),
    editOffer: builder.mutation<
      { status: StatusType; errors: string[] },
      { salesOfferPayload: FormData; offerId: number }
    >({
      query: ({ salesOfferPayload, offerId }) => ({
        url: `/sales_offers/${offerId}`,
        method: 'PUT',
        body: salesOfferPayload,
      }),
      invalidatesTags: ['Offers'],
    }),
    deleteOffer: builder.mutation<{ status: StatusType }, { offerId: number }>({
      query: ({ offerId }) => ({
        url: `/sales_offers/${offerId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Offers'],
    }),

    getManageOfferList: builder.query<
      ManageOfferListing,
      { per_page?: number; page: number; order?: string }
    >({
      query: ({ per_page, page, order }) => ({
        url: `/sales_offers?per_page=${per_page ? per_page : 8}&page=${page}&order=${order ?? 'desc'}`,
      }),
      providesTags: ['Offers'],
    }),
  }),
})

export const {
  useGetRelatedOffersQuery,
  useGetSponseredOfferClientSecretMutation,
  useAddOfferMutation,
  useEditOfferMutation,
  useDeleteOfferMutation,
  useGetManageOfferListQuery,
} = offerApiSlice
